import * as React from 'react'
import { connect } from 'react-redux'
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import * as App from '../../../app/types'
import { Loading } from '../../../components/loading'
import * as RasaModal from '../../../components/modal'
import * as RasaInput from '../../../components/rasa-input'
import * as Actions from './actions'
import { AttributeGrid } from './attribute-grid'
import * as Types from './types'
import * as Utils from './utils'

interface ModalComponentState {
  modal: Types.ModalState,
}
type ModalProps = ModalComponentState &
                  RasaModal.DispatchState &
                  RasaModal.SubmitDispatchState<Types.ModalData> &
                  App.WrappedState

export const AddModalComponent = ({
  app,
  modal,
  showModal,
  submitModal,
  updateModal,
}: ModalProps) =>
  <Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
    <form>
      <ModalHeader toggle={showModal}>Add Subscriber</ModalHeader>
      <ModalBody>
        <Row>
          <Col sm="12" md="6">
            <RasaInput.RasaInput label="First Name"
                                placeholder=""
                                value={modal.data.first_name}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'first_name', value: e.target.value})} />
          </Col>
          <Col sm="12" md="6">
            <RasaInput.RasaInput label="Last Name"
                                placeholder=""
                                value={modal.data.last_name}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'last_name', value: e.target.value})} />
          </Col>
        </Row>
        <Row>
          <Col>
            <RasaInput.RasaInput label="Email"
                                placeholder=""
                                validation={RasaInput.validateOptionalEmail(modal.data.email)}
                                value={modal.data.email}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                  updateModal({name: 'email', value: e.target.value})} />
          </Col>
        </Row>
        <Row>
          <Col>
            <AttributeGrid attributes={modal.data.attributes}/>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {modal.isSubmitting && <Loading size={Loading.Sizes.SMALL} />}
        <Button color="primary"
                onClick={() => submitModal(app.selectedCommunity, modal.data)}
                disabled={modal.isSubmitting || !Utils.modalStateValid(modal.data)}>
          Add
        </Button>
        <Button onClick={showModal}>Cancel</Button>
      </ModalFooter>
    </form>
  </Modal>

export const AddModal = connect(
  ({app}: App.WrappedState) => ({app}),
  {
    showModal: Actions.showModal,
    submitModal: Actions.create,
    updateModal: Actions.updateModalField,
  },
)(AddModalComponent)



// WEBPACK FOOTER //
// ./src/pages/members/add-modal/component.tsx